module.exports = __webpack_public_path__ + "static/img/2.4e6c460.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/huoban/2.png
// module id = PxlW
// module chunks = 1